import { HomeHeading, HomeLink } from './presentation'
import styles from './home.module.css'

export function SmartForms() {
  return (
    <section
      className={`${styles.section} ${styles.soft}`}
      aria-labelledby="home-smart-title"
    >
      <div className={styles.container}>
        <HomeHeading id="home-smart-title" title="Forms that think for you">
          Start with AI, then tailor the journey. Ask relevant questions and
          guide each person to the right outcome.
        </HomeHeading>
        <HomeLink href="https://my.heyform.net/sign-up">
          Generate a form with AI
        </HomeLink>
        <div className={styles.aiGrid}>
          <div className={styles.aiLead}>
            <h3>From an idea to a first draft</h3>
            <p>
              Describe what you need. AI generates the questions so you can
              focus on the details.
            </p>
            <div className={styles.media}>
              <img
                src="/static/smart.webp"
                alt="Describe a form and add reference material in HeyForm's AI form generator"
                width={1910}
                height={1346}
                loading="lazy"
              />
            </div>
          </div>
          <div className={styles.aiDetails}>
            <div className={styles.detail}>
              <div className={styles.media}>
                <img
                  className={styles.detailImage}
                  src="/static/features/conditional-logic.webp"
                  alt="Branching rules in the HeyForm logic editor"
                  width={1000}
                  height={508}
                  loading="lazy"
                />
              </div>
              <h3>Conditional logic</h3>
              <p>
                Show the right questions at the right time. Adapt the flow based
                on each response.
              </p>
            </div>
            <div className={styles.detail}>
              <div className={styles.media}>
                <img
                  className={styles.detailImage}
                  src="https://s2.loli.net/2024/10/04/c8rkzH1JwpVIhWO.png"
                  alt="Different form endings based on a respondent's answers"
                  width={1350}
                  height={686}
                  loading="lazy"
                />
              </div>
              <h3>Multiple endings</h3>
              <p>
                One form, multiple outcomes. Show different results, redirect
                users, or trigger the next step.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
